import * as React from "react";
import { ReactPortal } from "react";
import MarqueeRenderer from "components/flexComponents/SponsoredContentRenderer/renderer/marquee";
import { RendererProps } from "components/flexComponents/SponsoredContentRenderer/renderer/renderer";

const Renderer = ({ singleAdRequest }: RendererProps) => {
  if (!singleAdRequest) return null;
  const coll: ReactPortal[] = [];
  if (singleAdRequest.marquees) {
    const marqueePortals = MarqueeRenderer.getMarqueePortals(singleAdRequest.marquees);
    if (marqueePortals) {
      coll.push(...marqueePortals);
    }
  }

  return coll.length > 0 ? <div>{coll}</div> : null;
};

export default Renderer;
